export const GET_ALL_NOTIFICATIONS_STATUS = "GET_ALL_NOTIFICATIONS_STATUS";
export const RESET_DATA = "RESET_DATA";
export const START_LOADING_NOTIFICATIONS_STATUS = "START_LOADING_NOTIFICATIONS_STATUS";
export const STOP_LOADING_NOTIFICATIONS_STATUS = "STOP_LOADING_NOTIFICATIONS_STATUS";
export const ERROR_LOADING_NOTIFICATIONS_STATUS = "ERROR_LOADING_NOTIFICATIONS_STATUS";